import * as React from "react";
import { Button } from "primereact/button";
import { Contract } from "../types";
import { api } from "../api";
import { useShowToast } from "../contexts/ToastContext.tsx";
import { extractApiError } from "../api/errors.ts";

export const UploadContract = ({
  contractData,
}: {
  contractData: Contract;
}) => {
  const showToast = useShowToast();
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const [uploadContractFile, { isLoading }] =
    api.endpoints.uploadContractFileApiContractsContractIdUploadPost.useMutation();

  const handleFileSelect = React.useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (!file) {
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      try {
        await uploadContractFile({
          contractId: contractData.id,
          bodyUploadContractFileApiContractsContractIdUploadPost: formData,
        }).unwrap();

        showToast({
          severity: "success",
          summary: "Sukces",
          detail: "Plik został przesłany pomyślnie",
        });

        // Reset the file input so the same file can be uploaded again if needed
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } catch (error) {
        console.error(error);
        const errorDetail =
          typeof error === "object" && error !== null
            ? extractApiError(error)
            : "Wystąpił błąd podczas przesyłania pliku";
        showToast({
          severity: "error",
          summary: "Błąd",
          detail: errorDetail,
        });

        // Reset the file input on error as well
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    },
    [contractData.id, uploadContractFile, showToast],
  );

  const handleButtonClick = React.useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          void handleFileSelect(e);
        }}
        accept=".docx,.pdf"
      />
      <Button
        icon="pi pi-upload"
        text
        size="small"
        aria-label="Przesłać plik"
        title="Przesłać plik"
        onClick={handleButtonClick}
        loading={isLoading}
        disabled={isLoading}
      />
    </>
  );
};
